export const iconFontAwesomeMedicalHealthXRay = (
	<i className="fa-solid fa-x-ray"></i>
);
